module.exports = __webpack_public_path__ + "static/RUmobSlide8-27de356d89f30713ea11ad25efb06b0e.jpg";